<template>
  <v-menu offset-y left>
    <template #activator="{ on, attrs }">
      <ui-icon-button v-if="compact" icon="mdi-download-outline" size="sm" :label="$t('finance_nav_export')" :disabled="disabled" v-bind="attrs" v-on="on" />
      <button v-else type="button" class="ui-btn" :disabled="disabled" v-bind="attrs" v-on="on">
        <v-icon size="16">mdi-download-outline</v-icon>
        <span>{{ $t("finance_nav_export") }}</span>
        <v-icon size="16">mdi-menu-down</v-icon>
      </button>
    </template>
    <v-list dense>
      <v-list-item @click="exportCsvFile">
        <v-list-item-icon class="mr-2"><v-icon small>mdi-file-delimited-outline</v-icon></v-list-item-icon>
        <v-list-item-title>CSV</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('print')">
        <v-list-item-icon class="mr-2"><v-icon small>mdi-file-pdf-box</v-icon></v-list-item-icon>
        <v-list-item-title>PDF ({{ $t("print") }})</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { exportCsv } from "@/utils/csvExport";

/**
 * Izvoz ekrana: CSV se pravi od podataka koji su već na ekranu (getData -> { headers, rows }), a PDF je štampa stranice
 * (backend nema export; PDF obračuna stiže sa Settlement fazom). `compact` je samo okruglo dugme sa ikonom (telefon, da stane u red
 * sa ostalim alatima).
 */
export default {
  name: "FinanceExport",
  props: {
    filename: { type: String, required: true },
    getData: { type: Function, required: true },
    disabled: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  methods: {
    exportCsvFile() {
      const { headers, rows } = this.getData();
      exportCsv(this.filename, headers, rows);
    },
  },
};
</script>
